import React from "react";

import Schedule from "./content";

const SchedulePage = () => {
	return <Schedule/>;
};

export default SchedulePage;
